import { toRaw } from 'vue'
import type { DataGrid, GridColumnInfo, GridToDetailConfig } from '../types'

function toPlainHistoryState(
  state: Record<string, unknown>
): Record<string, unknown> {
  const plain = toRaw(state)
  try {
    return structuredClone(plain) as Record<string, unknown>
  } catch {
    return JSON.parse(JSON.stringify(plain)) as Record<string, unknown>
  }
}

function resolveDetailParams(
  row: Record<string, unknown>,
  toDetail: GridToDetailConfig
) {
  if (toDetail.params && typeof toDetail.params === 'object') {
    return toPlainHistoryState({ ...toDetail.params })
  }
  if (row?.id != null) {
    return toPlainHistoryState({ id: toRaw(row.id) })
  }
  return {}
}

export function useNavigate($grid: DataGrid) {
  $grid.handleToDetail = (row, column: GridColumnInfo) => {
    const toDetailFn = column.toDetail
    if (!toDetailFn) return

    const toDetail = toDetailFn(row, column)
    if (!toDetail?.name) return

    const router = $grid.router
    if (!router) {
      console.warn('[ZGrid] toDetail requires vue-router')
      return
    }

    const state = resolveDetailParams(row, toDetail)
    router.push({
      name: toDetail.name,
      ...(toDetail.routeParams ? { params: toDetail.routeParams } : {}),
      ...(toDetail.query ? { query: toDetail.query } : {}),
      state: Object.keys(state).length ? state : undefined,
    })
  }
}
